export class PayrollRequest {
	date: string;
	endDate: string;
	paymentPeriod: number = 4;
	payments: [] = [];
	period: string;
}

export class ExtraPaymentRequest {
	amount: number = 0;
	description: string;
	discounts: number = 1;
	employees: number[] = [];
	paymentType: string;
	recurrent?: boolean;
}